export let InvoiceOperation;
(function (InvoiceOperation) {
  InvoiceOperation["EDIT"] = "EDIT";
  InvoiceOperation["CLONE"] = "CLONE";
  InvoiceOperation["CREATE_BLANK_INVOICE"] = "CREATE_BLANK_INVOICE";
  InvoiceOperation["CONVERT_TO_INVOICE"] = "CONVERT_TO_INVOICE";
})(InvoiceOperation || (InvoiceOperation = {}));